<template>
    <CFormLabel class="col-sm-1 col-form-label"
                v-if="this.$filters.nvl(this.defaultLabel, '')"
    >{{ this.dateLabel }}</CFormLabel>
    <CCol :sm="2">
        <Datepicker week-start="0" id="startDate"
                    v-model="this.bgnde"
                    format="yyyyMMdd"
                    placeholder="yyyymmdd"
                    locale="ko-KR"
                    autoApply
                    :text-input="{format:'yyyyMMdd'}"
                    :enableTimePicker="this.$filters.nvl(this.enableTimePicker, false)"
                    @keyup.enter="this.$emit('getList',1)"
                    maxlength="8"
                    :week-numbers="this.$filters.getWeeknumbers"
                    week-num-name="주"
                    />
<!--      week-start="0"-->
    </CCol>
    <CCol :sm="2">
        <Datepicker week-start="0" id="endDate"
                    v-model="this.endde"
                    format="yyyyMMdd"
                    placeholder="yyyymmdd"
                    locale="ko-KR"
                    autoApply
                    :text-input="{format:'yyyyMMdd'}"
                    :enableTimePicker="this.$filters.nvl(this.enableTimePicker, false)"
                    @keyup.enter="this.$emit('getList',1)"
                    maxlength="8"
                    :week-numbers="this.$filters.getWeeknumbers"
                    week-num-name="주"
                    />
      <!--      week-start="0"-->
    </CCol>
    <CCol :sm="4" style="min-width: 220px"
          v-if="this.$filters.nvl(this.enableAll, 'true') == 'true'">
        <CInputGroup style="height:100%;">
            <CButtonGroup role="group" aria-label="Button group with nested dropdown">
                <CButton type="button" color="light"
                         @click="this.setDayFn()" style="min-width: 50px!important;">전체</CButton>
                <CButton type="button" color="light"
                         v-if="this.enableCurMonth"
                         @click="this.setTodayFn('-1m')" style="min-width: 50px!important;">전월</CButton>
                <CButton type="button" color="light"
                       v-if="this.enableCurMonth"
                       @click="this.setTodayFn('m')" style="min-width: 50px!important;">당월</CButton>

                <CDropdown variant="btn-group" v-if="this.$filters.nvl(this.enableToday, false)">
                  <CDropdownToggle color="light">일</CDropdownToggle>
                  <CDropdownMenu>
                    <CDropdownItem @click="this.setTodayFn(-1)">이전1일</CDropdownItem>
                    <CDropdownItem @click="this.setTodayFn()">당일</CDropdownItem>
                    <CDropdownItem @click="this.setTodayFn('w')">이번주</CDropdownItem>
                    <CDropdownItem @click="this.setTodayFn(1)">이후1일</CDropdownItem>
                    <CDropdownItem @click="this.setTodayFn(-7)">7일전</CDropdownItem>
                    <CDropdownItem @click="this.setTodayFn(7)">7일후</CDropdownItem>
                  </CDropdownMenu>
                </CDropdown>
                <CDropdown variant="btn-group">
                    <CDropdownToggle color="light">월</CDropdownToggle>
                    <CDropdownMenu>
                        <CDropdownItem @click="this.setDayFn('1', '1')">1월</CDropdownItem>
                        <CDropdownItem @click="this.setDayFn('2', '2')">2월</CDropdownItem>
                        <CDropdownItem @click="this.setDayFn('3', '3')">3월</CDropdownItem>
                        <CDropdownItem @click="this.setDayFn('4', '4')">4월</CDropdownItem>
                        <CDropdownItem @click="this.setDayFn('5', '5')">5월</CDropdownItem>
                        <CDropdownItem @click="this.setDayFn('6', '6')">6월</CDropdownItem>
                        <CDropdownItem @click="this.setDayFn('7', '7')">7월</CDropdownItem>
                        <CDropdownItem @click="this.setDayFn('8', '8')">8월</CDropdownItem>
                        <CDropdownItem @click="this.setDayFn('9', '9')">9월</CDropdownItem>
                        <CDropdownItem @click="this.setDayFn('10', '10')">10월</CDropdownItem>
                        <CDropdownItem @click="this.setDayFn('11', '11')">11월</CDropdownItem>
                        <CDropdownItem @click="this.setDayFn('12', '12')">12월</CDropdownItem>
                    </CDropdownMenu>
                </CDropdown>
                <CDropdown variant="btn-group">
                    <CDropdownToggle color="light">분기</CDropdownToggle>
                    <CDropdownMenu>
                        <CDropdownItem @click="this.setDayFn('1', '3')">1분기(1~3)</CDropdownItem>
                        <CDropdownItem @click="this.setDayFn('4', '6')">2분기(4~6)</CDropdownItem>
                        <CDropdownItem @click="this.setDayFn('7', '9')">3분기(7~9)</CDropdownItem>
                        <CDropdownItem @click="this.setDayFn('10', '12')">4분기(10~12)</CDropdownItem>
                    </CDropdownMenu>
                </CDropdown>
                <CDropdown variant="btn-group">
                    <CDropdownToggle color="light">반기</CDropdownToggle>
                    <CDropdownMenu>
                        <CDropdownItem @click="this.setDayFn('1', '6')">상반기(1~6)</CDropdownItem>
                        <CDropdownItem @click="this.setDayFn('7', '12')">하반기(7~12)</CDropdownItem>
                    </CDropdownMenu>
                </CDropdown>
              <CDropdown variant="btn-group">
                <CDropdownToggle color="light">년도</CDropdownToggle>
                <CDropdownMenu>
                  <CDropdownItem @click="this.setYearFn(new Date().getFullYear())">{{new Date().getFullYear()}}</CDropdownItem>
                  <template v-for="index in 11" :key="index">
                    <CDropdownItem @click="this.setYearFn(new Date().getFullYear() - index)">{{ new Date().getFullYear() - index }}</CDropdownItem>
                  </template>
                </CDropdownMenu>
              </CDropdown>
            </CButtonGroup>
        </CInputGroup>
    </CCol>
</template>

<script>

export default {
    name: 'periodSelected',
    props: [
        "defaultLabel", //기간선택 문구
        "defaultBgnde", // 시작일자 기본
        "defaultEndde", // 종료일자 기본
        "update:bgnde",
        "update:endde",

        "enableTimePicker", // 시간 선택 유무
        "enableToday", // 오늘 선택 유무
        "enableCurMonth", // 당월 선택 유무유무
        "enableYearSel", //
        "enableAll", //
    ],
    data() {
        return {
            bgnde: null,
            endde: null,
            dateLabel: null,
        }
    },
    methods: {
        setTodayFn:function (dateType = null){
          let date = new Date();

          if(dateType == null) {
            this.bgnde = this.$filters.getStrDate(date);
            this.endde = this.$filters.getStrDate(date);
          }
          else if(dateType === 'w') {
            let chgDate = date;
            const theDayOfWeek = date.getDay();
            this.bgnde = this.$filters.getStrDate(chgDate.setDate(chgDate.getDate()-theDayOfWeek+1));
            this.endde = this.$filters.getStrDate(chgDate.setDate(chgDate.getDate()-theDayOfWeek+8));
          }
          else if(dateType === '-1m') {
            let chgDate = date;
            this.endde = this.$filters.getStrDate(date.setDate(0));
            this.bgnde = this.$filters.getStrDate(chgDate.setDate(1));
          }
          else if(dateType === 'm') {
            let chgDate = date;
            this.endde = this.$filters.getStrDate(date);
            this.bgnde = this.$filters.getStrDate(chgDate.setDate(1));
          }
          else if(dateType === -1) {
            // eslint-disable-next-line no-undef
            let chgDate = new Date(this.bgnde);
            if(this.bgnde == null) chgDate = new Date();
            chgDate = chgDate.setDate(chgDate.getDate()-1);

            this.bgnde = this.$filters.getStrDate(chgDate);
            this.endde = this.$filters.getStrDate(chgDate);
          }
          else if(dateType === 1) {
            // eslint-disable-next-line no-undef
            let chgDate = new Date(this.endde);
            if(this.endde == null) chgDate = new Date();
            chgDate = chgDate.setDate(chgDate.getDate()+1);

            this.bgnde = this.$filters.getStrDate(chgDate);
            this.endde = this.$filters.getStrDate(chgDate);

          } else if(dateType === -7) {
            // eslint-disable-next-line no-undef
            let chgDate = new Date();
            this.endde = this.$filters.getStrDate(chgDate);
            this.bgnde = this.$filters.getStrDate(chgDate.setDate(chgDate.getDate()-7));

          } else if(dateType === 7) {
            // eslint-disable-next-line no-undef
            let chgDate = new Date(this.endde);
            if(this.endde == null) chgDate = new Date();
            this.bgnde = this.$filters.getStrDate(chgDate.setDate(chgDate.getDate()+1));
            this.endde = this.$filters.getStrDate(chgDate.setDate(chgDate.getDate()+6));
          }
          this.$emit('update:endde', this.endde);
          this.$emit('update:bgnde', this.bgnde);
          this.$emit('getList',1);
        },
        setDay(s, e){
          this.bgnde = s;
          this.endde = e;
          this.$emit('update:endde', this.endde);
          this.$emit('update:bgnde', this.bgnde);
        },
        clearDay(){
          this.bgnde = null;
          this.endde = null;
          this.$emit('update:endde', this.endde);
          this.$emit('update:bgnde', this.bgnde);
        },
        // 기간선택 자동계산 함수
        setDayFn(first, last){
            if( this.$filters.nvl(first, "") == "" || this.$filters.nvl(last, "") == "" ){
                this.bgnde = null;
                this.endde = null;
            }else{
                let date = new Date();
                let year = date.getFullYear();

                this.bgnde = this.$filters.getStrDate(new Date(year, first-1, 1));
                this.endde = this.$filters.getStrDate(new Date(year, last, 0));
            }
            this.$emit('update:endde', this.endde);
            this.$emit('update:bgnde', this.bgnde);
            this.$emit('getList',1);
        },
      // 기간선택 자동계산 함수
      setYearFn(year){
        if( this.$filters.nvl(year, "") == ""){
          this.bgnde = null;
          this.endde = null;
        }else{
          this.bgnde = this.$filters.getStrDate(new Date(year, 0, 1));
          this.endde = this.$filters.getStrDate(new Date(year, 11, 31));
        }
        this.$emit('update:endde', this.endde);
        this.$emit('update:bgnde', this.bgnde);
        this.$emit('getList',1);
      },
    },
    created() {
        this.bgnde = this.$filters.nvl(this.defaultBgnde, "") != "" ? new Date(this.defaultBgnde) : null;
        this.endde = this.$filters.nvl(this.defaultEndde, "") != "" ? new Date(this.defaultEndde) : null;
        this.dateLabel = this.$filters.nvl(this.defaultLabel, "") != "" ? this.defaultLabel : "기간선택";
    },
    watch: {
        bgnde() { // 옵션 선택
            this.$emit('update:bgnde', this.bgnde);
        },
        endde() { // 옵션 선택
            this.$emit('update:endde', this.endde);
        },
    },
}
</script>
